import { CartItem } from '@modules/BillOfMaterials/Components/TemplateCart/CartItem/CartItem';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import css from './TemplateCart.module.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OrderSummary from '@modules/BillOfMaterials/Components/TemplateCart/OrderSummary/OrderSummary';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { ArrowIcon } from '@shared/Icons/ArrowIcon';
import { ROUTES } from '@configs/AppRoutes';

export const TemplateCart: React.FC = () => {
    const [isDesktop] = useMediaType();
    const navigate = useNavigate();
    const { tempId } = useParams();

    const handleGoBack = () => {
        if (tempId) {
            navigate(ROUTES.TEMPLATE_INFO.getPath(tempId));
        }
    };

    return (
        <section className={css.section}>
            {!isDesktop && <div className={css.header}>Shopping Cart</div>}
            <div className={css.wrapper}>
                <CartItem />
                {isDesktop && (
                    <BasicButton
                        extraClassName={css.backDesktopBtn}
                        onClick={handleGoBack}
                    >
                        <div className={css.btnContent}>
                            <ArrowIcon
                                iconClassName={css.arrow}
                                height={8}
                                width={16}
                                fill="currentColor"
                            />
                            BACK
                        </div>
                    </BasicButton>
                )}
            </div>

            <OrderSummary />
            {!isDesktop && (
                <BasicButton className={css.backBtn} onClick={handleGoBack}>
                    ← Back
                </BasicButton>
            )}
        </section>
    );
};
